import { usePortal } from "../../../../Providers/PortalProvider";
import AppBar from "../../Components/AppBar";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import React from "react";
import Container from "@material-ui/core/Container";
import * as Sentry from "@sentry/react";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
export default () => {
    const portal = usePortal();
    const [t] = useTranslation();
    const userConsentForSessionReplay = sessionStorage.getItem("sessionReplayConsent") === "true";
    const handleChange = () => {
        sessionStorage.setItem("sessionReplayConsent", userConsentForSessionReplay ? "false" : "true");
        // If we have a valid session, we stop it, so it's sent to sentry
        if (userConsentForSessionReplay) {
            const replay = Sentry.getReplay();
            if (replay) {
                replay
                    .stop()
                    .then(() => {
                    document.location.reload();
                })
                    .catch((err) => {
                    Sentry.captureException(err);
                    alert("Error stopping debug mode");
                });
            }
            else {
                // We were not recording?
                document.location.reload();
            }
        }
        else {
            document.location.reload();
        }
    };
    if (!navigator.cookieEnabled) {
        return (React.createElement(MobilePage, null,
            React.createElement(AppBar, null),
            React.createElement(PageHeader, null,
                React.createElement(Trans, null, "Debug")),
            React.createElement(Container, null, "Cookies are not enabled. This page will not work without cookies enabled")));
    }
    return (React.createElement(MobilePage, null,
        React.createElement(AppBar, null),
        React.createElement(PageHeader, null,
            React.createElement(Trans, null, "Debug")),
        React.createElement(Container, null,
            React.createElement("p", null,
                React.createElement(Trans, null, "You probably got to this page because you have problems when using our webpage.")),
            React.createElement("p", null,
                React.createElement(Trans, null, "This page enables you to record browser session which is then used by our software department for figuring out the source of your problem.")),
            React.createElement("p", null,
                React.createElement(Trans, null, "Click 'Start recording' when you're ready to record a session, then get back here and click end session when you're done.")),
            React.createElement(Box, { display: "flex", justifyContent: "center" },
                React.createElement(Button, { onClick: handleChange, variant: "contained", color: "primary" }, userConsentForSessionReplay
                    ? t("Stop recording")
                    : t("Start recording"))))));
};
